import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'evi-desktop-source-item',
  templateUrl: './source-item.component.html',
  styleUrls: ['./source-item.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SourceItemComponent {
  public readonly itemClicked = output<void>();

  public name = input.required<string>();
  public isActive = input<boolean>(false);
  public iconName = input<string>('');

  public onItemClicked(): void {
    this.itemClicked.emit();
  }
}
